import { managerInstance } from "libs/api";

import { CompanyManager, CreateManagerRequest } from "../../managers.types";

export const requestCreateManager = async (
  body: CreateManagerRequest
): Promise<CompanyManager> => {
  return await managerInstance.post("/delivery-company/managers", body);
};
